import type { ReactNode } from 'react';

interface Props {
	colSpan: number;
	message: string;
	/** Optional action rendered under the message (e.g. a retry button on an error row). */
	action?: ReactNode;
}

export function EmptyTableRow({ colSpan, message, action }: Props) {
	return (
		<tr>
			<td colSpan={colSpan} className="p-6 text-center text-gray-400 text-sm">
				{message}
				{action && <div className="mt-3">{action}</div>}
			</td>
		</tr>
	);
}
